import { useEffect, useState } from "react";
import {
  Box, Typography, Paper, Table, TableHead,
  TableRow, TableCell, TableBody, Button,
  TextField, Stack, Dialog, Chip, Grid,
  Alert
} from "@mui/material";

import { stockService }           from "../service/CreateStockService";
import { sellBikeService }        from "../service/SellBikeService";
import api                        from "../service/api";
import CreateStockForm            from "../component/CreateStockForm";
import SellBikeForm               from "../component/SellBikeForm";
import UpdateStockForm from "../component/Updatestockform";
  import TransferDialog from "../component/TransferDialog";
import PasswordPromptDialog from "../component/Passwordpromptdialog";
 
const CreateStock = () => {
 
  const [data, setData]       = useState([]);
  const [search, setSearch]   = useState("");

  const [openCreate, setOpenCreate] = useState(false);
  const [openSell,   setOpenSell]   = useState(false);
  const [openView,   setOpenView]   = useState(false);

  // ── NEW: password gate + update form ──────────────────────────────────────
  const [openPasswordPrompt, setOpenPasswordPrompt] = useState(false);
  const [openUpdate,         setOpenUpdate]          = useState(false);
  const [bikeToEdit,         setBikeToEdit]          = useState(null);
  // ─────────────────────────────────────────────────────────────────────────

  const [selectedBike, setSelectedBike] = useState(null);
  const [viewData,     setViewData]     = useState(null);

  const [form, setForm] = useState({
    customerName: "",
    mobile: "",
    address: "",
    salePrice: "",
    saleType: "CASH",
    cashAmount: "",
    financeCompany: "",
    financeAmount: "",
    exchange: {}
  });
const [openTransfer, setOpenTransfer] = useState(false);
   // 🔄 FETCH STOCK
  const fetchStock = async () => {
    const res = await stockService.getAvailableStock();
    let bikes = [];
    res.data?.forEach(loc => bikes.push(...loc.bikes));
    setData(bikes);
  };

  useEffect(() => { fetchStock(); }, []);

  // 🔍 FILTER
  const filtered = data.filter((b) => {
    const searchText = search.toLowerCase();
    return (
      (b.engine || "").toLowerCase().includes(searchText) ||
      (b.chasis || "").toLowerCase().includes(searchText) ||
      (b.model  || "").toLowerCase().includes(searchText)
    );
  });

  // 🔥 SELL OPEN
  const handleSellOpen = (bike) => {
    setSelectedBike(bike);
    setOpenSell(true);
  };

  // 👁 VIEW OPEN
  const handleView = async (id) => {
    const res = await api.get(`/specific-bike-details/${id}`);
    setViewData(res.data.data);
    setOpenView(true);
  };

  // ✏️ EDIT – step 1: open password prompt
  const handleEditClick = (bike) => {
    setBikeToEdit(bike);
    setOpenPasswordPrompt(true);
  };

  // ✏️ EDIT – step 2: password verified → open update form
  const handlePasswordSuccess = () => {
    setOpenPasswordPrompt(false);
    setOpenUpdate(true);
  };

  // ✏️ EDIT – cancel password prompt
  const handlePasswordClose = () => {
    setOpenPasswordPrompt(false);
    setBikeToEdit(null);
  };
const handleTransferOpen = (bike) => {
  setSelectedBike(bike);
  setOpenTransfer(true);
};

const handleTransferClose = () => {
  setOpenTransfer(false);
  setSelectedBike(null);
};
  // ✏️ EDIT – close update form
  const handleUpdateClose = () => {
    setOpenUpdate(false);
    setBikeToEdit(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSell = async () => {
    await sellBikeService.sellBike({ bikeId: selectedBike._id, ...form });
    setOpenSell(false);
    fetchStock();
  };

  return (
<Box
  sx={{
    ml: {
      xs: 0,        // mobile
      sm: 0,        // small screen
      lg: '210px'   // large screen
    }
  }}
>      <Typography variant="h4">Stock Management</Typography>

      {/* 🔍 SEARCH */}
      <Stack direction="row" spacing={2} mt={2} mb={2}>
        <TextField
          fullWidth
          placeholder="Search engine / chasis..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button variant="contained" onClick={() => setOpenCreate(true)}>
          + ADD STOCK
        </Button>
      </Stack>

      {/* 📊 TABLE */}
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Model</TableCell>
              <TableCell>Colour</TableCell>
              <TableCell>Engine</TableCell>
              <TableCell>Chasis</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Source</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered.map((bike) => (
              <TableRow key={bike._id}>
                <TableCell>{bike.model}</TableCell>
                <TableCell>{bike.colour}</TableCell>
                <TableCell>{bike.engine || "N/A"}</TableCell>
                <TableCell>{bike.chasis || "N/A"}</TableCell>
                <TableCell>{bike.location}</TableCell>
                <TableCell>₹{bike.purchasePrice}</TableCell>

                <TableCell>
                  <Chip
                    label={bike.source}
                    color={bike.source === "NEW" ? "primary" : "warning"}
                  />
                </TableCell>

            <TableCell>
  <Stack direction="row" spacing={1}>
    <Button onClick={() => handleView(bike._id)}>👁</Button>

    {/* ✏️ password-gated */}
    <Button onClick={() => handleEditClick(bike)}>✏️</Button>

    {/* ✅ SELL (disabled for EXCHANGE) */}
    <Button
      variant="contained"
      color="success"
      disabled={bike.source === "EXCHANGE"}
      onClick={() => handleSellOpen(bike)}
    >
      SELL
    </Button>

    {/* 🔁 TRANSFER BUTTON */}
   <Button
  variant="outlined"
  color="primary"
  onClick={() => handleTransferOpen(bike)}
  sx={{
    "&:hover": {
      backgroundColor: "#1976d2", // hover bg
      color: "#fff",              // text color
      borderColor: "#1976d2",     // border color
    },
  }}
>
  TRANSFER
</Button>
  </Stack>
</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* ➕ CREATE */}
      <Dialog open={openCreate} onClose={() => setOpenCreate(false)} fullWidth maxWidth="md">
        <CreateStockForm
          onSuccess={fetchStock}
          onClose={() => setOpenCreate(false)}
        />
      </Dialog>

      {/* 💰 SELL */}
      <Dialog open={openSell} onClose={() => setOpenSell(false)} fullWidth maxWidth="md">
        <SellBikeForm
          bike={selectedBike}
          onClose={() => setOpenSell(false)}
          onSuccess={fetchStock}
        />
      </Dialog>

      {/* 🔐 PASSWORD PROMPT (step 1 of edit) */}
    

 <PasswordPromptDialog
        open={openPasswordPrompt}
        onClose={handlePasswordClose}
        onSuccess={handlePasswordSuccess}
        type="stockUpdate"                  // ✅ matches schema enum
        title="Verify to Edit Sale Record"
      />

      {/* ✏️ UPDATE FORM (step 2 of edit – opens only after password ok) */}
      <Dialog open={openUpdate} onClose={handleUpdateClose} fullWidth maxWidth="md">
        <UpdateStockForm
          bike={bikeToEdit}
          onClose={handleUpdateClose}
          onSuccess={fetchStock}
        />
      </Dialog>

      {/* 👁 VIEW */}
      <Dialog open={openView} onClose={() => setOpenView(false)} fullWidth maxWidth="md">
        <Box p={3} sx={{ background: "#f8fafc" }}>
          <Typography variant="h6" fontWeight={700} mb={2}>
            Bike Full Details
          </Typography>

          {!viewData ? (
            <Alert severity="info">No data found</Alert>
          ) : (
            <Grid container spacing={2}>

              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2, borderRadius: 2 }}>
                  <Typography fontWeight={700} mb={1}>🚗 Bike Info</Typography>
                  <Typography><b>Model:</b> {viewData?.stockDetails?.model || "-"}</Typography>
                  <Typography><b>Engine:</b> {viewData?.stockDetails?.engine || "-"}</Typography>
                  <Typography><b>Chasis:</b> {viewData?.stockDetails?.chasis || "-"}</Typography>
                  <Typography><b>Colour:</b> {viewData?.stockDetails?.colour || "-"}</Typography>
                  <Typography><b>SKU:</b> {viewData?.stockDetails?.skuCode || "-"}</Typography>
                  <Typography><b>Key No:</b> {viewData?.stockDetails?.keyNumber || "-"}</Typography>
                  <Typography><b>Purchase Price:</b> ₹{viewData?.stockDetails?.purchasePrice || 0}</Typography>
                  <Typography><b>Ex-Showroom:</b> ₹{viewData?.stockDetails?.exShowroomPrice || 0}</Typography>
                  <Typography><b>Location:</b> {viewData?.stockDetails?.location || "-"}</Typography>
                  <Typography><b>Status:</b> {viewData?.currentStatus || "-"}</Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2, borderRadius: 2 }}>
                  <Typography fontWeight={700} mb={1}>👤 Created By</Typography>
                  <Typography><b>Name:</b> {viewData?.stockDetails?.createdBy?.name || "-"}</Typography>
                  <Typography><b>Email:</b> {viewData?.stockDetails?.createdBy?.email || "-"}</Typography>
                  <Typography>
                    <b>Date:</b>{" "}
                    {viewData?.stockDetails?.date
                      ? new Date(viewData.stockDetails.date).toLocaleString()
                      : "-"}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 2, borderRadius: 2 }}>
                  <Typography fontWeight={700} mb={1}>🔁 Transfer History</Typography>
                  {viewData?.transferHistory?.length > 0 ? (
                    viewData.transferHistory.map((t, i) => (
                      <Box key={i} sx={{ mb: 1, p: 1, borderBottom: "1px solid #eee" }}>
                        <Typography><b>{t?.fromLocation || "-"}</b> ➝ <b>{t?.toLocation || "-"}</b></Typography>
                        <Typography>By: {t?.transferredBy?.name || "-"}</Typography>
                        <Typography>
                          Date: {t?.date ? new Date(t.date).toLocaleString() : "-"}
                        </Typography>
                      </Box>
                    ))
                  ) : (
                    <Typography>No transfer history</Typography>
                  )}
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 2, borderRadius: 2 }}>
                  <Typography fontWeight={700} mb={1}>💰 Sale Info</Typography>
                  {viewData?.saleDetails ? (
                    <>
                      <Typography><b>Customer:</b> {viewData.saleDetails.customerName || "-"}</Typography>
                      <Typography><b>Price:</b> ₹{viewData.saleDetails.salePrice || 0}</Typography>
                      <Typography><b>Type:</b> {viewData.saleDetails.saleType || "-"}</Typography>
                    </>
                  ) : (
                    <Typography>Bike not sold yet</Typography>
                  )}
                </Paper>
              </Grid>

            </Grid>
          )}
        </Box>
      </Dialog>
<TransferDialog
  open={openTransfer}
  onClose={handleTransferClose}
  bike={selectedBike}
  onSuccess={fetchStock}
/>
    </Box>
  );
};

export default CreateStock;